import { useState } from 'react';
import dayjs from 'dayjs';

export default function useAlertForm() {
  const [isTelehealth, setIsTelehealth] = useState(false);
  const [isPeerRequested, setIsPeerRequested] = useState(false);
  const [isCTI, setIsCTI] = useState(false);
  const [isMinor, setIsMinor] = useState(false);
  const [isInjectable, setIsInjectable] = useState(false);
  const [existingClinic, setExistingClinic] = useState('');
  const [alertZIP, setAlertZIP] = useState('');
  const [insuranceProvider, setInsuranceProvider] = useState('');
  const [preferredLanguage, setPreferredLanguage] = useState('');
  const [diagnosisCode, setDiagnosisCode] = useState('');
  const [dischargeDate, setDischargeDate] = useState(dayjs());
  const [isIOP, setIsIOP] = useState(false);
  const [isPROS, setIsPROS] = useState(false);
  const [isPartialHospital, setIsPartialHospital] = useState(false);
  const [isOnTrack, setIsOnTrack] = useState(false);
  const [secondDiagnosisCode, setSecondDiagnosisCode] = useState('');
  const [otherInsuranceOption, setOtherInsuranceOption] = useState('');
  const [isDayRehab, setIsDayRehab] = useState(false);
  const [isMAT, setIsMAT] = useState(false);
  const [isOTP, setIsOTP] = useState(false);

  return {
    isTelehealth,
    setIsTelehealth,
    isPeerRequested,
    setIsPeerRequested,
    isCTI,
    setIsCTI,
    isMinor,
    setIsMinor,
    isInjectable,
    setIsInjectable,
    existingClinic,
    setExistingClinic,
    alertZIP,
    setAlertZIP,
    insuranceProvider,
    setInsuranceProvider,
    preferredLanguage,
    setPreferredLanguage,
    diagnosisCode,
    setDiagnosisCode,
    secondDiagnosisCode,
    setSecondDiagnosisCode,
    dischargeDate,
    setDischargeDate,
    isIOP,
    setIsIOP,
    isPROS,
    setIsPROS,
    isPartialHospital,
    setIsPartialHospital,
    isOnTrack,
    setIsOnTrack,
    otherInsuranceOption,
    setOtherInsuranceOption,
    isDayRehab,
    setIsDayRehab,
    isMAT,
    setIsMAT,
    isOTP,
    setIsOTP,
  };
}
